import { useState, useEffect } from 'react';
import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import * as notificationActions from "../../Redux/Actions/notifications";
import { toastMessage } from "../../utils/toast";

const SnoozeModal = ({ t, showModal, handleModalClose, handleOk, selectedItems }) => {

    const [options, setOptions] = useState([]);  
    const [selectedOption, setSelectedOption] = useState(1); 
    const [loading, setLoading] = useState(false);

    useEffect(()=> {
        setOptions([
            { value: "1 hour", key: "1" },
            { value: "2 Hours", key: "2" },
            { value: "3 Hours", key: "3" },
            { value: "6 Hours", key: "6" },
            { value: "12 Hours", key: "12" },
            { value: "1 Day", key: "24" },
            { value: "2 Days", key: "48" },
            { value: "3 Days", key: "72" },
            { value: "4 Days", key: "96" },
            { value: "5 Days", key: "120" },
            { value: "6 Days", key: "144" },
            { value: "1 Week", key: "168" },
            { value: "2 Weeks", key: "336" },
        ]);
    }, []);

    const selectHandler = (e) => {
        setSelectedOption(e.target.value);
    }

    const submitHandler = () => {
        notificationActions.snoozeSetOn(selectedOption, selectedItems).then((res) => {
          handleOk();  
          if (res && res.data) {    
            window.location.reload();
          } else { 
            toastMessage(
              "error",
              (res && res.message) || "something went wrong, Try again later"
            );
          }
        });
      };
    
    return (
    <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{'Select snooze duration'}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleModalClose}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body" style={{width:'70%'}}>
                             <label className="modal-body-centered">{'Time duration'}</label>
                                <select className="ms-3" onChange={selectHandler}>
                                    <option value="" disabled={true}>{'Select duration'}</option>
                                    {options.map(option => (
                                        <option value={option.key} key={option.key}>{option.value}</option>
                                    ))}             
                                </select>
                         </div>
                        <div className="modal-footer">
                            <button type="button" disabled={loading} className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={()=>{setLoading(true); submitHandler();}}>
                                {t("Submit")} {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}}/>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
);

}

export default SnoozeModal;